import { UpcomingMatchCard as UpcomingMatchCardProps } from '@/app/libs/match/types'
import UpcomingMatchCard from '../upcoming-match-card'

export default function UpcomingMatches({
  upcomingMatchData
}: {
  upcomingMatchData: UpcomingMatchCardProps[]
}) {
  return (
    <>
      <p className="text-lg font-bold text-textOffWhite mb-3">Next Matches</p>
      <div className="grid grid-cols-2 gap-3 w-full">
        {upcomingMatchData?.map(match => {
          return (
            <div className="col-span-2 md:col-span-1" key={match?._id}>
              <UpcomingMatchCard card={match} />
            </div>
          )
        })}
      </div>
    </>
  )
}
